import { forwardRef, ForwardRefRenderFunction } from 'react';
import styled from '@emotion/styled';
import { Input as BaseInput, Icon, InputProps } from 'roo-ui/components';
import { themeGet } from 'styled-system';

const InputWrapper = styled.div`
  position: relative;
`;

const InputIcon = styled(Icon)`
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  left: ${themeGet('space.3')};
  pointer-events: none;
`;

const Input = styled(BaseInput)`
  padding-left: ${themeGet('space.10')};
`;

interface InputWithIconProps extends InputProps {
  iconName: string;
}

const InputWithIcon: ForwardRefRenderFunction<HTMLInputElement, InputWithIconProps> = ({ iconName, ...rest }, ref) => (
  <InputWrapper>
    <Input ref={ref} {...rest} />
    <InputIcon name={iconName} />
  </InputWrapper>
);

export default forwardRef(InputWithIcon);
